import React from 'react';

import SocialMediaButtons from './SocialMediaButtons';
import image from '../../resources/prof_picture.jpeg';

const GeneralInfo = ({}) => (
<div className='general-info'>
    <div>
    <div><img src={image} /></div>
    <div className='about-info'>
        <div className='name'>Devjeet Roy</div>
        <div className='phd'>PhD Student</div>
        <div className='subject'>Computer Science</div>
        <div className='school'>Washington State University</div>
    </div>
    
    </div>
    <SocialMediaButtons />
</div>)

export default GeneralInfo;